/*
 * The genealogy window's size, in a module of its own: the page reserves the
 * window's box from it before the story (a lazily loaded chunk) arrives.
 */

/**
 * The window's height, in layout px at its base width: the cell's passport
 * (where the story rests) whole, so no line of it is cut at rest; on the
 * pack's page that is its header down to the top of the Related passports
 * card, and the story's camera shows the rest.
 */
export const GENEALOGY_HEIGHT = Object.freeze({ 860: 690 });

/**
 * The height (CSS px) the window takes in a frame `width` CSS px wide, laid
 * out at `baseWidth`: as VignetteFrame fits it, scaled down to the frame and
 * never up.
 */
export function genealogyWindowHeight(width, baseWidth) {
    return GENEALOGY_HEIGHT[baseWidth] * (width > 0 ? Math.min(1, width / baseWidth) : 1);
}
